// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookingBillingSplitPaymentResponse

export type WidgetBookingBillingSplitPaymentApiResponse = {
	fee: number;
	delay: number;
};

export type WidgetBookingBillingSplitPayment = {
	fee: number;
	delay: number;
};

export function hydrateWidgetBookingBillingSplitPayment(data: WidgetBookingBillingSplitPaymentApiResponse): WidgetBookingBillingSplitPayment {
	return { ...data };
}